import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';
import {ProcessWorkingTableColumn} from './ProcessWorkingTableColumn';

export class ProcessWorkingTable extends ConnectBasicEntity {
name: string;
orderedWorkingTableColumns: {[key: string]: ProcessWorkingTableColumn};
processCode: string;
schema: string;
visionCode: string;
workingTableColumns: {[key: string]: ProcessWorkingTableColumn};
}

